
export class LoadAccountChannelsFromApi {
    public static readonly type: string = '[Accounts API] Load account channels';
}
